import CoachingPage from '../../js/pages/CoachingPage';

import {isAdmin} from '../../../server/services/users';
import {getPublicCoachingData} from '../../../server/services/coaching';
import {getRecommendedCoaches} from '../../../server/services/recommendations/coaches';
import UserProfile from '../../../server/models/user_profile';

import {CoachAvailableStatuses, CoachAvailableStatusesAdmin} from '../../../lib/constants/coaching';

export default CoachingPage;

export async function getServerSideProps({req, query}) {
  let statuses = CoachAvailableStatuses;
  let recommendedCoaches = [];

  if (req.user) {
    const [profile, isAdminUser] = await Promise.all([
      UserProfile.get(req.user.id),
      isAdmin(req.user.id),
    ]);
    const roles = profile.career_tracks || [];
    const companies = profile.interview_companies || [];

    recommendedCoaches = (await getRecommendedCoaches(roles, companies))
      ?.map((coach) => coach.slug);

    if (isAdminUser) statuses = CoachAvailableStatusesAdmin;
  }

  const {coaches, tags, companies} = await getPublicCoachingData(statuses);

  return {
    props: {
      coaches,
      tags,
      companyLogos: companies,
      recommendedCoaches,
      query,
    },
  };
}
